import { render, staticRenderFns } from "./AdWorkspace.vue?vue&type=template&id=c65c82bc&scoped=true&"
import script from "./AdWorkspace.vue?vue&type=script&lang=js&"
export * from "./AdWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./AdWorkspace.vue?vue&type=style&index=0&id=c65c82bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65c82bc",
  null
  
)

export default component.exports